import { render, staticRenderFns } from "./manage-filters.vue?vue&type=template&id=7b7ecb7c&scoped=true&"
import script from "./manage-filters.vue?vue&type=script&lang=js&"
export * from "./manage-filters.vue?vue&type=script&lang=js&"
import style0 from "./manage-filters.vue?vue&type=style&index=0&id=7b7ecb7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7ecb7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b7ecb7c')) {
      api.createRecord('7b7ecb7c', component.options)
    } else {
      api.reload('7b7ecb7c', component.options)
    }
    module.hot.accept("./manage-filters.vue?vue&type=template&id=7b7ecb7c&scoped=true&", function () {
      api.rerender('7b7ecb7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/manage-filters.vue"
export default component.exports